import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const PrinterMasterReadSlice = createSlice({
  name: "PrinterMasterReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    printerMasterRead: (state) => {
      state.isLoading = true;
    },
    successPrinterMasterRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurePrinterMasterRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearPrinterMasterRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  printerMasterRead,
  failurePrinterMasterRead,
  successPrinterMasterRead,
  clearPrinterMasterRead,
} = PrinterMasterReadSlice.actions;

export default PrinterMasterReadSlice.reducer;
